<template>
    <header :style="{opacity: $route.name !== 'player' ? 1 : 0}" class="header__desktop show-nav">
        <nav ref="nav" :class="['header__desktop-nav', {'is-dd': $route.name === 'directors-single' || $route.name === 'private-pages-details' }]">
            <div class="header__desktop-nav-item js-nav-item">
                <router-link class="header__desktop-nav-links" :to="{name: 'directors'}">Directors</router-link>
            </div>
            <div class="header__desktop-nav-item js-nav-item">
                <router-link class="header__desktop-nav-links" :to="{name: 'work'}">Work</router-link>
            </div>
            <div @mouseenter="onMouseEnterLogo" class="header__desktop-nav-logo">
                <router-link :to="{name: 'home'}" exact>
                    <div ref="scene-logo-container" class="scene-logo-container"></div>
                </router-link>
            </div>
            <div class="header__desktop-nav-item js-nav-item">
                <a class="header__desktop-nav-links" href="https://ubiquity.tv/n/print">Print</a>
            </div>
            <div class="header__desktop-nav-item js-nav-item">
                <router-link class="header__desktop-nav-links" :to="{name: 'contact'}">Contact</router-link> 
            </div>
        </nav>
    </header>
</template>

<script>

// Components
import IconHeaderLogo from '../icons/icon-header-logo'

// Scene
import SceneLogo from '../../helpers/threejs/scenes/SceneLogo'
import MyEmitter from '../../helpers/MyEmitter'
import params from '../../utils/params'
import gsap from 'gsap'

export default {
    components: {
        "icon-header-logo": IconHeaderLogo,
    },
    name: "layout-header-desktop",

    // Router

    beforeDestroy: function(){
        MyEmitter.off(params.Events.logoGoHeader, this.animateHeaderUp)
        MyEmitter.off(params.Events.logoGoMiddle, this.animateHeaderDown)
    },
    mounted: function(){

        // Events
        MyEmitter.on(params.Events.logoGoHeader, this.animateHeaderUp)
        MyEmitter.on(params.Events.logoGoMiddle, this.animateHeaderDown)

        // Start scene
        this.sceneLogo = new SceneLogo(this.$refs["scene-logo-container"], {
            rendererAlpha: true,
            premultipliedAlpha: false
        }, {
            startAt: this.$route.name,
            navItems: this.$el.querySelectorAll(".js-nav-item")
        })
        this.sceneLogo.init()
        this.sceneLogo.start()

        gsap.to(this.$el, {
            duration: 0,

            top: "50%",
            y: "-50%"
        })
    },

    methods: {
        animateHeaderUp: function(justMove = false, onComplete = null){

            if(this.sceneLogo._logoMode === "header") {
                onComplete && onComplete()
                return;
            }

            if(!justMove) this.sceneLogo._animateToHeaderState()

            gsap.to(this.$el, {
                duration: 1.2, // according duration in SceneLogo._animateToHeaderState(),
                ease: justMove ? params.Animations.easeInOut : params.Animations.easeDecrement,
                onComplete: () => {
                    onComplete && onComplete()
                },

                top: 0,
                y: "0%"
            })
        },

        animateHeaderDown: function(onComplete){

            if(this.sceneLogo._logoMode === "middle") {
                onComplete && onComplete()
                return;
            }

            this.sceneLogo._animateToMiddleState()

            gsap.to(this.$el, {
                duration: 1.2, // according duration in SceneLogo._animateToHeaderState()
                ease: params.Animations.easeDecrement,
                onComplete: onComplete,

                top: "50%",
                y: "-50%"
            })
        },

        onMouseEnterLogo: function(){
            this.sceneLogo && this.sceneLogo._onMouseEnterLogo()
        },
    }
}
</script>

<style lang="scss">

    .body-page-home .header__desktop-nav-logo a{
        pointer-events: none;
    }
    .header__desktop{
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        // height: 93px;
        z-index: 10;
        padding: 43px 60px;
        pointer-events: none;
        z-index: 21;

        .scene-logo-container{
            @include absolute-center();
            width: 100vw;
            height: 100vh;
            pointer-events: none;
        }

        .icon__header-logo{
            width: 157px;
        }

        &.show-nav &{
            &-nav-item{
                opacity: 0;
                visibility: hidden;
            }
        }

        &-nav{
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            // Directors signle
            &.is-dd &{
                &-item{
                    opacity: 0!important;
                    visibility: hidden!important;
                }
            }

            &-logo{
                a{
                    display: inline-block;
                    width: 23vw; // related to slider
                    height: 45px;
                    pointer-events: all;
                }
            }

            &-item{
                pointer-events: all;
                opacity: 0;
                visibility: hidden;
                transition: ease-out .5s;
                transition-property: opacity, visibility;
                
                
                a{
                    padding: 20px 4px
                }
            }


            &-links{
                font-size: ptToPx(11);
                text-transform: uppercase;
                letter-spacing: 4px;

                &:hover, &.router-link-active{
                    font-weight: 700;
                }
            }
        }
    }
</style>